import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { BodyText } from '@ui-components/typography/Typography'
import { ReactNode } from 'react'
import { IntlShape } from 'react-intl'

import { OpenModalEvent } from './modalMachine'

export const getOpenErrorPromptModalEvent = (
  onConfirm: () => void,
  intl: IntlShape,
  header = intl.formatMessage({ id: 'common-error-technical-title' }),
  message: ReactNode = intl.formatMessage({ id: 'common-error-technical-text' }),
  visualMode: ModalVisualMode.TechnicalError | ModalVisualMode.Banned = ModalVisualMode.TechnicalError,
  requestId?: string,
): OpenModalEvent => {
  return {
    type: 'OPEN',
    data: {
      header,
      children: <BodyText tagName="p">{message}</BodyText>,
      primaryButtonOptions: {
        type: 'secondary',
        label: intl.formatMessage({ id: 'common-ok' }),
        onClick: onConfirm,
      },
      mode: visualMode,
      requestId,
    },
  }
}
